import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import cn from 'classnames';

const ProfileTabs = ({ activeTab }) => {
	return (
		<ul className="nav nav-tabs">
			<li
				role="presentation"
				className={cn({ active: activeTab === 'profile' })}
			>
				<Link to="/profile">Profile</Link>
			</li>
			<li role="presentation" className={cn({ active: activeTab === 'pic' })}>
				<Link to="/profile/pic">Profile Photo</Link>
			</li>
			<li
				role="presentation"
				className={cn({ active: activeTab === 'start-page' })}
			>
				<Link to="/profile/start-page">Start Page</Link>
			</li>
			<li
				role="presentation"
				className={cn({ active: activeTab === 'sms-alerts' })}
			>
				<Link to="/profile/sms-alerts">Alerts</Link>
			</li>
			<li
				role="presentation"
				className={cn({ active: activeTab === 'adt-notification-prefs' })}
			>
				<Link to="/profile/adt-notification-prefs">
					ADT Notification Preferences
				</Link>
			</li>
		</ul>
	);
};

ProfileTabs.propTypes = {
	activeTab: PropTypes.string.isRequired,
};

export default ProfileTabs;
